var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1002_7249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1002_7249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_2",
    d: "M13.502 10.5417H4.95824C4.80463 10.5417 4.67602 10.4903 4.57241 10.3873C4.4688 10.2846 4.41699 10.1569 4.41699 10.0044C4.41699 9.85192 4.4688 9.72283 4.57241 9.61713C4.67602 9.5113 4.80463 9.45838 4.95824 9.45838H13.502L9.60658 5.56297C9.49949 5.45588 9.44324 5.3297 9.43783 5.18442C9.43255 5.03915 9.48755 4.90547 9.60283 4.78338C9.71824 4.66936 9.84727 4.61366 9.98991 4.6163C10.1325 4.61894 10.2602 4.67672 10.3728 4.78963L15.1105 9.53338C15.1803 9.60324 15.2311 9.67665 15.263 9.75359C15.2951 9.83054 15.3112 9.9138 15.3112 10.0034C15.3112 10.0928 15.2951 10.1761 15.263 10.2532C15.2311 10.3301 15.183 10.4007 15.1189 10.4648L10.377 15.2067C10.2616 15.3221 10.136 15.3777 10.0003 15.3734C9.86463 15.3691 9.73908 15.3099 9.62366 15.1959C9.50838 15.0738 9.45074 14.9416 9.45074 14.7994C9.45074 14.6572 9.50838 14.5307 9.62366 14.4198L13.502 10.5417Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forward-arrow.399ef78827516c1e823e48ce4752f20a.svg";
export { ForwardRef as ReactComponent };